import React, { useEffect, useState } from 'react';
import socialData from './static/socialData';
import SocialShareButton from './SocialShareButton';
import Container from './styles';

const SocialSharing = ({ description, isSticky, placement, shareText, pageUrl }) => {
  const [pagePath, setPagePath] = useState(null);
  const [pageTitle, setPageTitle] = useState(null);

  useEffect(() => {
    if (placement) {
      if (window) {
        setPagePath(window.location.pathname);
      }
      if (document) {
        setPageTitle(document.title);
      }
    }
  });

  const handleClick = (platform) => {
    if (typeof window !== 'undefined') {
      dataLayer.push({
        event: 'social interaction',
        social_action: 'share',
        social_network: platform,
        page_path: window.location.href,
      });
    }
  };

  return (
    <Container
      className={`social-sharing-container ${placement}`}
      placement={placement}
      isSticky={!!isSticky}
    >
      {socialData.map((platform, index) => (
        <SocialShareButton
          key={index}
          className={platform.class}
          handleClick={handleClick}
          placement={placement}
          platform={platform}
          title={shareText || pageTitle}
          url={`http://www.servicetitan.com${pagePath || pageUrl}`}
          description={description}
        />
      ))}
    </Container>
  );
};

export default SocialSharing;

SocialSharing.defaultProps = {
  isSticky: true,
};
